const translations = {
    addOrganization: 'Add organization',
    allOrganizationsConnectedMessage:
        'Every Exedy Drone Data Manager organization on your account is already connected. To add another, create or join one in the Exedy Drone Data Manager, then come back here.',
    allOrganizationsConnectedTitle: 'All organizations already connected',
    close: 'Close',
    connect: 'Connect',
    ddmDescription: 'This connection allows you to sync flights from the Exedy Drone Data Manager.',
    ddmTitle: 'Exedy Drone Data Manager',
    disconnect: 'Disconnect',
    lastSynced: 'Last synced',
    syncNow: 'Sync now'
};

export default translations;
